import { z } from 'zod';
import {
    type ControlSocketKind,
    type NodeSocketCfg,
} from './base-node';
import { baseConnectionCfgSchema, connectionNodeConfigSchema } from './connection.zod';

export const torqueToolConsumerNodeCfgSchema = connectionNodeConfigSchema(baseConnectionCfgSchema.extend({
    kind: z.literal('torqueToolConsumer'),
    controlValues: baseConnectionCfgSchema.shape.controlValues.merge(z.object({
    })),
}));
interface TorqueToolConsumerCfgSchema extends z.infer<typeof torqueToolConsumerNodeCfgSchema> {}

export const torqueToolConsumerNodeSocketCfg = {
    controlSockets: {
        outputs: () => {
            const ret: Record<'goodTighteningEvent' | 'badTighteningEvent', ControlSocketKind> = {
                goodTighteningEvent: 'event',
                badTighteningEvent: 'event',
            };
            return ret;
        },
        inputs: () => {
            const ret = {};
            return ret;
        },
    },
    dataSockets: {
        outputs: () => {
            const ret: {
                angle: 'number';
                torque: 'number';
            } = {
                angle: 'number',
                torque: 'number',
            };
            return ret;
        },
        inputs: () => {
            return {};
        },
    },
} satisfies NodeSocketCfg<TorqueToolConsumerCfgSchema>;
